import { TableColumnType } from 'antd';
import { useCallback, useMemo, useState } from 'react';
import { SorterResult } from 'antd/lib/table/interface';

import { Compensation } from 'types';
import { getSorter } from 'helpers';

export const useColumnsWithSort = <T>(columns: TableColumnType<T>[], defaultSortedColumn?: string) => {
  const [sorterResult, setSorterResult] = useState<SorterResult<Compensation>>();

  const getSortOrder = useCallback(
    (columnKey: string) => {
      if (!sorterResult?.order) {
        return columnKey === defaultSortedColumn ? 'descend' : null;
      }

      return columnKey === sorterResult.field ? sorterResult.order : null;
    },
    [sorterResult, defaultSortedColumn],
  );

  const columnsWithSort = useMemo(() => {
    return columns.map(({ sorter, ...column }) => ({
      ...column,
      sorter:
        sorter === undefined && typeof column.dataIndex === 'string'
          ? getSorter<T>((row) => row[column.dataIndex as keyof T])
          : sorter,
      sortOrder: getSortOrder((column.dataIndex || column.key) as string),
    }));
  }, [columns, getSortOrder]);

  return { columnsWithSort, onSorterChange: setSorterResult };
};
